module.exports = __webpack_public_path__ + "img/img48.587f6b0b.svg";